import { IPromotionState } from '../types';

export const unselectServices = (services: IPromotionState['services']): IPromotionState['services'] => {
  return services.map(service => ({
    ...service,
    selected: false,
  }));
};
